var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pattern__base"},[_c('steps-display'),_c('div',{staticClass:"tracks__wrapper"},_vm._l((_vm.tracks),function(track){return _c('Track',{key:'track-' + track.id,attrs:{"track":track}})}),1),_c('steps-display')],1)}
var staticRenderFns = []

export { render, staticRenderFns }